// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__vT5As","buttons":"Footer_buttons__4-Q8m"};